import { useTranslation } from 'react-i18next';
import LoadsImportResultCard from './components/loads-import-result-card/loads-import-result-card';
import './loads-import-result.scss';
import LoadsImportResultTable from './components/loads-import-result-table';
import ILoadImportResultProps from './interfaces/ILoadImportResultProps';

function LoadsImportResult({
    loadsNumbers,
    loadsResult,
}: Readonly<ILoadImportResultProps>) {
    const { t } = useTranslation();

    return (
        <div className="loads-import-result__container">
            <div className="loads-import-result-table__header-container">
                <div
                    className="loads-import-result-table__header"
                    data-testid="loads-import-result-table__header"
                >
                    <h1>{t('Resumo')}</h1>
                    <div
                        className="loads-import-result-table__header-cards"
                        data-testid="loads-import-result-table__header-cards"
                    >
                        <LoadsImportResultCard
                            item={t('Cargas')}
                            description={t('Recebidas')}
                            itemValue={loadsNumbers.loadsReceived.toString()}
                        />

                        <LoadsImportResultCard
                            item={t('Cargas')}
                            description={t('Processadas')}
                            itemValue={loadsNumbers.loadsProcessed.toString()}
                            itemValueColor="#4BA68D"
                        />

                        <LoadsImportResultCard
                            item={t('CargasCom')}
                            description={t('Erro')}
                            itemValue={loadsNumbers.loadsNotProcessed.toString()}
                            itemValueColor="#C92323"
                        />
                    </div>
                </div>
            </div>

            <div className="loads-import-result-table__body-container">
                <div
                    className="loads-import-result-table__body"
                    data-testid="loads-import-result-table__body"
                >
                    <h1>{t('CargasRecebidasComErroTitutlo')}</h1>
                    <p>{t('CargasRecebidasComErroDescricao')}</p>
                    <div
                        className="loads-import-result-table_body-table"
                        data-testid="loads-import-result-table__body-table"
                    >
                        <LoadsImportResultTable data={loadsResult} />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default LoadsImportResult;
